import { render, staticRenderFns } from "./StarPicker.vue?vue&type=template&id=25a68657&scoped=true"
import script from "./StarPicker.vue?vue&type=script&lang=js"
export * from "./StarPicker.vue?vue&type=script&lang=js"
import style0 from "./StarPicker.vue?vue&type=style&index=0&id=25a68657&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a68657",
  null
  
)

export default component.exports